"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardStore = exports.AlertType = void 0;
const api_1 = require("client/api");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
var AlertType;
(function (AlertType) {
    AlertType["Null"] = "null";
    AlertType["Claim"] = "claim";
    AlertType["Inventory"] = "inv";
    AlertType["Provider"] = "prov";
    AlertType["Site"] = "site";
    AlertType["Order"] = "order";
    AlertType["PurchaseOrder"] = "po";
    AlertType["User"] = "user";
    AlertType["Admin"] = "admin"; // should only be used for manually created alerts for with Recipient=Everyone
})(AlertType = exports.AlertType || (exports.AlertType = {}));
class DashboardStore {
    constructor() {
        this.user = {
            loading: true,
            value: null
        };
        this.submission = {};
        this.submitted = false;
        this.newLogin = true;
        this.alerts = [];
        this.backorderData = [];
        // C-097 Outstanding Payments
        this.totalProviderPage = 1;
        this.currentPage = 1;
        this.getUploads = () => {
            if (this.provider.uploads.length > 0) {
                return this.provider.uploads;
            }
            else {
                return [];
            }
        };
        this.getClaimStatistics = async (siteId, todayOnly, insuranceOnly) => api_1.DashboardEndpoint.claimStats.apiCall(null, {
            siteId,
            todayOnly,
            insuranceOnly
        });
        this.getDispenseStatistics = async (siteId) => api_1.DashboardEndpoint.dispensedStats.apiCall(null, { siteId });
        this.providerImage = async (providerId) => {
            await this.getProviderWidget(providerId);
            if (this.provider.uploads.length > 0) {
                const imageUpload = this.provider.uploads.find((upload) => upload.informationType === "providerImage");
                if (imageUpload) {
                    return imageUpload.filePath;
                }
                else {
                    return "";
                }
            }
            else {
                return "";
            }
        };
        this.getProviderWidget = async (providerId) => {
            const provider = await api_1.DashboardEndpoint.providerWidget.apiCall(null, {
                providerId
            });
            this.provider = provider.providerData;
            return;
        };
        // C-097 Outstanding Payments
        this.getPaymentWidget = async (query = { page: 1, limit: 25 }) => {
            const result = await api_1.DashboardEndpoint.paymentWidget.apiCall({
                query
            });
            if (api_1.isError(result)) {
                return { success: false, error: "Unable to load payments." };
            }
            return { success: true, orders: result.paymentData,
                totalProviderPage: result.totalPages,
                currentPage: result.currentPage
            };
        };
        this.clearAlerts = async (options) => {
            const result = await api_1.DashboardEndpoint.clearalerts.apiCall(null, Object.assign({}, options));
            if (api_1.isError(result)) {
                console.log("error in clearing alerts", result);
            }
            else {
                console.log("result from clearAlerts is ", result);
            }
        };
        this.testMailMessage = async () => {
            const result = await api_1.DashboardEndpoint.testmailmessage.apiCall(null);
            // console.log("result from test claim message is ", result);
        };
        this.deleteProviderAsset = async (uploadId) => {
            const result = await api_1.DashboardEndpoint.removeFile.apiCall({
                params: { id: uploadId }
            });
            await this.getProviderWidget(this.provider.id);
        };
        this.upload = async (files, providerId, uploadType) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newFile", file); // Why is name gone?
            });
            formData.append("providerId", providerId);
            formData.append("uploadType", uploadType);
            const response = await api_1.ProviderEndpoint.uploadFile.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
                await this.getProviderWidget(this.provider.id);
            }
        };
        /**
         * @desc Creates a new alert.
         * @param subject The subject of the alert.
         * @param message The body of the message to the alert.
         * @param siteId The ID of the pharmacy (site) to map to the alert.
         * @param groupId The ID of the permissions group to map to the alert.
         * @param type The type of reference to be made (i.e. refill = claim table).
         * @param typeRefId The ID you're referencing in the other table.
         */
        this.createAlert = async (alert) => {
            const response = await api_1.DashboardEndpoint.createAlert.apiCall(null, {
                alert
            });
            return response;
        };
        this.readAlert = async (userId) => {
            const response = await api_1.DashboardEndpoint.readAlert.apiCall(null, {
                userId
            });
            if (api_1.isError(response)) {
                console.error("Error: ", response);
            }
            else {
                this.alerts = response.alerts;
                return response.alerts;
            }
        };
        this.loadBackorderData = async (query) => {
            const response = await api_1.DashboardEndpoint.loadbackorderdata.apiCall({
                query
            });
            if (api_1.isError(response)) {
                console.error("Error loading backorder data", response);
            }
            else {
                this.backorderData = response.backorderData;
            }
        };
        this.readMessage = async (userId, loadAlertsCount) => {
            const readAlerts = store_1.usersStore.permissions.ReadAlerts;
            const response = await api_1.DashboardEndpoint.readMessage.apiCall(null, {
                userId,
                readAlerts,
                loadAlertsCount
            });
            if (api_1.isError(response)) {
                console.log("Error: ", response);
            }
            else {
                this.alerts = response.message;
                return response.message;
            }
        };
        this.seenMessage = async (alertId, userId) => {
            const response = await api_1.DashboardEndpoint.seenMessage.apiCall(null, {
                alertId,
                userId
            });
            if (api_1.isError(response)) {
                console.log("Error: ", response);
            }
            else {
                return response.message;
            }
        };
        this.saveLayout = async (userId, layouts) => {
            const response = await api_1.DashboardEndpoint.saveLayout.apiCall(null, {
                userId,
                layouts
            });
            if (api_1.isError(response)) {
                console.log("Error: ", response);
            }
            else {
                console.log("save layout response: ", response);
                return response.message;
            }
        };
        this.getLayout = async (userId) => {
            const response = await api_1.DashboardEndpoint.getLayout.apiCall(null, {
                userId
            });
            if (api_1.isError(response)) {
                console.log("Error: ", response);
            }
            else {
                return response.message;
            }
        };
        /** This needs to be here because the react-grid package changes the array of layouts and takes out rows for widgets of lower level users */
        this.initializeLayouts = async (userId, layouts) => {
            const response = await api_1.DashboardEndpoint.defaultLayout.apiCall(null, {
                userId,
                layouts
            });
            if (api_1.isError(response)) {
                console.log("Error: ", response);
            }
            else {
                return response.message;
            }
        };
        mobx_1.autorun(async () => {
            this.user = await store_1.usersStore.user;
        });
    }
}
__decorate([
    mobx_1.observable
], DashboardStore.prototype, "user", void 0);
__decorate([
    mobx_1.observable
], DashboardStore.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], DashboardStore.prototype, "submission", void 0);
__decorate([
    mobx_1.observable
], DashboardStore.prototype, "submitted", void 0);
__decorate([
    mobx_1.observable
], DashboardStore.prototype, "newLogin", void 0);
__decorate([
    mobx_1.observable
], DashboardStore.prototype, "alerts", void 0);
__decorate([
    mobx_1.observable
], DashboardStore.prototype, "backorderData", void 0);
__decorate([
    mobx_1.observable
], DashboardStore.prototype, "totalProviderPage", void 0);
__decorate([
    mobx_1.observable
], DashboardStore.prototype, "currentPage", void 0);
__decorate([
    mobx_1.observable
], DashboardStore.prototype, "orders", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "getUploads", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "getClaimStatistics", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "getDispenseStatistics", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "providerImage", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "getProviderWidget", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "getPaymentWidget", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "clearAlerts", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "testMailMessage", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "deleteProviderAsset", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "upload", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "createAlert", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "readAlert", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "loadBackorderData", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "readMessage", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "seenMessage", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "saveLayout", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "getLayout", void 0);
__decorate([
    mobx_1.action
], DashboardStore.prototype, "initializeLayouts", void 0);
exports.dashboardStore = new DashboardStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/store.ts
// module id = 342
// module chunks = 0